// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Sub Tabs Component */
/**
 * Base Styles/Mixins for Ids Sub Tabs Component and all subcomponents.
 */
:host {
  display: block;
}

.ids-sub-tabs {
  display: block;
  margin-block-end: 0;
  margin-block-start: 0;
  padding-inline-start: 0;
}
.ids-sub-tabs.ids-sub-tabs-wrapped {
  display: flex;
  flex-flow: column wrap;
  max-height: 90vh;
  max-width: 100vw;
  width: max-content;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-tabs/ids-sub-tabs.scss","webpack://./src/components/ids-tabs/ids-sub-tabs-base.scss"],"names":[],"mappings":"AAAA,2BAAA;ACAA;;EAAA;ADGA;EACE,cAAA;AAEF;;AACA;ECFE,cAAA;EACA,mBAAA;EACA,qBAAA;EACA,uBAAA;ADKF;AAFE;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EAKA,kBAAA;AAAJ","sourcesContent":["/* Ids Sub Tabs Component */\n@use './ids-sub-tabs-base' as *;\n\n:host {\n  display: block;\n}\n\n.ids-sub-tabs {\n  @include reset-menu-style();\n\n\n  &.ids-sub-tabs-wrapped {\n    display: flex;\n    flex-flow: column wrap;\n    max-height: 90vh;\n    max-width: 100vw;\n\n    // NOTE: \"width: max-content\" doesn't work in Safari and Firefox\n    // So added \"aftershow\" menu event to configure with manually\n    // @see IdsMenuGroup.configureMegaMenu()\n    width: max-content;\n  }\n}\n","/**\n * Base Styles/Mixins for Ids Sub Tabs Component and all subcomponents.\n */\n// Resets the User-Agent stylesheet rules for `<ul>` in Chrome\n@mixin reset-menu-style() {\n  display: block;\n  margin-block-end: 0;\n  margin-block-start: 0;\n  padding-inline-start: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
